// extracted by mini-css-extract-plugin
export default {"small":"kAxTkwvWy97ke352PKZA","selected":"OmMxlJsReQxdFi9BQ69g","secondary":"s64B6nVM7XygXPKH0XBM","neutral":"guPfqUv0ZsvqdLxBBAfV"};